import { useMemo } from 'react';
import { DataTable, DataTableBody } from '@optiaxiom/react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { UserInstruction } from '../../types';

import createColumns from './columns';

type InstructionTabTableProps = {
  filteredInstructions?: UserInstruction[];
  handleEditInstruction: (instruction: UserInstruction) => void;
  handleDeleteInstruction: (instruction: UserInstruction) => void;
  getProductSku: (instruction: UserInstruction) => string[];
};

export const InstructionTabTable = ({
  filteredInstructions,
  handleEditInstruction,
  handleDeleteInstruction,
  getProductSku,
}: InstructionTabTableProps) => {
  const columns = useMemo(
    () =>
      createColumns({
        handleEditInstruction,
        handleDeleteInstruction,
        getProductSku,
      }),
    [handleEditInstruction, handleDeleteInstruction, getProductSku]
  );

  const table = useReactTable({
    columns,
    data: filteredInstructions ?? [],
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <DataTable table={table}>
      <DataTableBody />
    </DataTable>
  );
};
